<template>
  <div id="pc-header">
    <logo-in-header class="pull-left"></logo-in-header>

    <div id="right-navbar" class="pull-right">
      <ul>
        <li class="header-list dropdown">
          <a class="nickname main-link" href="javascript:void(0)" data-toggle="dropdown" role="button"
             aria-haspopup="true" aria-expanded="false">
            <img src="/static/img/dashboard/avatar_2x.png" alt="Account: ">{{ nickname }}
            <span class="caret"></span>
          </a>
          <account-info-list></account-info-list>
        </li>

        <li class="header-list">
          <router-link to="/" class="main-link">{{ $t('index') }}</router-link>
        </li>

        <li class="header-list">
          <router-link to="/download">{{ $t('download') }}</router-link>
        </li>

        <li class="header-list">
          <router-link to="/faq">{{ $t('faq') }}</router-link>
        </li>

        <li>
          <Choose-lang :className="'dashboard-header'"></Choose-lang>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import LogoInHeader from '../../logoInHeader/LogoInHeader.vue'
  import AccountInfoList from './accountInfoList/AccountInfoList.vue'
  import ChooseLang from '../../ChooseLang.vue'
  import locales from './lang'
  import { mapState } from 'vuex'

  export default {
    name: 'user-center-header-pc',
    components: {
      LogoInHeader,
      AccountInfoList,
      ChooseLang
    },
    data: function () {
      return {
        isOpen: false
      }
    },
    locales,
    computed: {
      nickname() {
        return this.$store.state.user['nickname']
      },
      ...mapState({
        hasToken: state => state.hasToken,
        user: state => state.user,
        specialHeader: state => state.header.specialHeader,
        bigstCount: state => state.header.bigstCount,
        isLoginPage: state => state.header.isLoginPage,
        isdownload: state => state.header.isdownload,
        isHeader: 'isHeader'
      })
    },
    methods: {
      openLeftSidebar: function () {
        this.isOpen = !this.isOpen
        this.$store.commit('setIsOpenLeftSidebar', this.isOpen)
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../../assets/scss/variables";

  * {
    padding: 0;
    margin: 0;
  }

  #pc-header {
    position: fixed;
    z-index: 9;
    background: #fff;
    width: 100%;
    padding: 0 .24rem 0 .3rem;
    height: .8rem;
    line-height: .8rem;
    border-bottom: 1px solid #E0D7E3;
  }

  #right-navbar {
    li {
      list-style: none;
      float: left;
    }
    a {
      font-size: .16rem;
      color: #333333;
      letter-spacing: 0;
    }
    .header-list {
      margin-right: .4rem;
    }
    .nickname {
      img {
        max-width: .4rem;
        margin-right: .08rem;
      }
      .caret {
        margin-left: .06rem;
        border-top-color: #333333;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// UserCenterHeaderPc.vue?2f5ec03a